var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"device-bg-main"}},[_c('timer'),(_vm.getWorker)?_c('list-projects-page'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }